var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3739 9.71921C32.9962 3.90899 26.7086 0 19.5039 0C9.70203 0 1.59176 7.23068 0.209548 16.6487C0.160378 16.9813 0.120769 17.3173 0.0893555 17.6553C1.5904 21.4933 5.5028 22.9179 5.5028 22.9179C9.54838 24.4182 13.581 23.6458 17.4135 21.1942C19.8283 19.6494 21.9296 17.6949 24.022 15.735C26.1138 13.775 28.4753 11.9093 31.2868 11.3507C33.4735 10.9157 35.818 11.3459 37.7144 12.5157C37.3409 11.5433 36.8915 10.609 36.3745 9.71921H36.3739Z",
    fill: "url(#paint0_linear_2511_2649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5264 22.8522C30.3499 23.3561 28.4214 24.6018 26.6404 25.9512C24.8593 27.3 23.163 28.7819 21.2126 29.8725C17.7673 31.7983 13.5967 32.3863 9.75329 31.489C6.44868 30.7173 3.41586 28.8515 1.20801 26.2763C3.96015 33.7105 11.113 39.0099 19.5039 39.0099C28.7458 39.0099 36.4804 32.5802 38.4937 23.9516C36.8704 22.6589 34.5649 22.3803 32.5264 22.8522Z",
    fill: "url(#paint1_linear_2511_2649)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7145 12.5157C35.8174 11.3459 33.4736 10.9156 31.287 11.3507C28.4754 11.91 26.1139 13.7757 24.0221 15.735C21.9297 17.6949 19.8284 19.6494 17.4136 21.1942C13.5811 23.6458 9.54848 24.4182 5.50291 22.9178C5.50291 22.9178 1.5905 21.4926 0.0894616 17.6553C0.0320969 18.2645 0 18.8804 0 19.5046C0 21.8859 0.428186 24.1662 1.20876 26.2757C3.41593 28.8503 6.44943 30.7167 9.75404 31.4884C13.5975 32.3857 17.768 31.7977 21.2133 29.8719C23.1637 28.782 24.8601 27.3001 26.6411 25.9506C28.4221 24.6019 30.35 23.3556 32.5271 22.8516C34.5656 22.3797 36.8711 22.6583 38.4944 23.9511C38.8277 22.5217 39.01 21.035 39.01 19.5039C39.01 17.04 38.5484 14.6853 37.7152 12.515L37.7145 12.5157Z",
    fill: "url(#paint2_linear_2511_2649)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0782 8.50781C12.9949 8.51532 12.9369 8.55767 12.9007 8.63961C12.6302 9.26175 12.3496 9.8791 12.0887 10.5046C11.8428 11.0933 11.429 11.4962 10.8431 11.7414C10.2298 11.9982 9.62337 12.2713 9.01353 12.5363C8.92953 12.5732 8.87148 12.6251 8.87012 12.7227C8.87148 12.8204 8.92953 12.873 9.01353 12.9092C9.62337 13.1742 10.2298 13.4473 10.8431 13.7041C11.429 13.9493 11.8428 14.3522 12.0887 14.9408C12.3496 15.5664 12.6302 16.1844 12.9007 16.8059C12.9362 16.8878 12.9942 16.9302 13.0782 16.9377C13.0823 16.9377 13.0864 16.9377 13.0912 16.937C13.0953 16.937 13.0994 16.9377 13.1042 16.9377C13.1875 16.9302 13.2455 16.8878 13.2817 16.8059C13.5522 16.1837 13.8328 15.5664 14.0937 14.9408C14.3396 14.3522 14.7534 13.9493 15.3393 13.7041C15.9526 13.4473 16.559 13.1742 17.1689 12.9092C17.2529 12.8723 17.3109 12.8204 17.3123 12.7227C17.3109 12.6251 17.2529 12.5725 17.1689 12.5363C16.559 12.2713 15.9526 11.9982 15.3393 11.7414C14.7534 11.4962 14.3396 11.0933 14.0937 10.5046C13.8328 9.8791 13.5522 9.26107 13.2817 8.63961C13.2462 8.55767 13.1882 8.51532 13.1042 8.50781C13.1001 8.50781 13.096 8.50781 13.0912 8.5085C13.0871 8.5085 13.083 8.50781 13.0782 8.50781Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0942 6.3418C9.04571 6.34658 9.01225 6.37048 8.99176 6.41828C8.83538 6.77818 8.67285 7.13534 8.52192 7.49797C8.37988 7.83874 8.14017 8.07161 7.80077 8.21366C7.44565 8.36185 7.09463 8.52029 6.74157 8.67394C6.69308 8.69511 6.65962 8.72516 6.65894 8.78184C6.65962 8.83852 6.69308 8.86857 6.74157 8.88974C7.09463 9.0434 7.44565 9.20115 7.80077 9.35003C8.14017 9.49207 8.37919 9.72495 8.52192 10.0657C8.67285 10.4277 8.83538 10.7855 8.99176 11.1454C9.01225 11.1925 9.04571 11.2171 9.0942 11.2219C9.09693 11.2219 9.09898 11.2219 9.10171 11.2219C9.10445 11.2219 9.10649 11.2219 9.10923 11.2219C9.15771 11.2171 9.19117 11.1932 9.21166 11.1454C9.36805 10.7855 9.53058 10.4283 9.68151 10.0657C9.82355 9.72495 10.0633 9.49207 10.4027 9.35003C10.7578 9.20183 11.1088 9.0434 11.4619 8.88974C11.5103 8.86857 11.5438 8.83852 11.5445 8.78184C11.5438 8.72516 11.5103 8.69511 11.4619 8.67394C11.1088 8.52029 10.7578 8.36253 10.4027 8.21366C10.0633 8.07161 9.82424 7.83874 9.68151 7.49797C9.53058 7.13602 9.36805 6.77818 9.21166 6.41828C9.19117 6.37116 9.15771 6.34658 9.10923 6.3418C9.10649 6.3418 9.10445 6.3418 9.10171 6.3418C9.09898 6.3418 9.09693 6.3418 9.0942 6.3418Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2511_2649",
    x1: -0.855795,
    y1: 11.8417,
    x2: 38.0934,
    y2: 11.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FF9D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF9350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2511_2649",
    x1: 9.629,
    y1: 37.4071,
    x2: 30.6921,
    y2: 16.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6460B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A1430A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#923D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#7A3307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#592403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2511_2649",
    x1: 4.56664,
    y1: 28.4562,
    x2: 36.1466,
    y2: 12.0438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF601C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C85C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B55114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#97410B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#742D01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe3b08e02b66f4cc6e480613c4581e62.svg";
export { ForwardRef as ReactComponent };